export default theme => ({
  subtitle: {
    marginLeft: theme.spacing.unit * 3,
  },
  checkboxCell: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkboxLabel: {
    marginRight: theme.spacing.unit * 2,
  },
  buttonContainer: {
    padding: theme.spacing.unit * 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  saveButton: {
    marginLeft: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/profile/cards/NotificationPreferenceCard/styles.js